<template>
  <div>
    <!--  table -->
    <b-row class="mt-3" style="padding-left: 17px; padding-right: 10px">
      <b-col cols="12" class="pt-0 pb-1" v-if="page == ''">
        <b-button
          variant="primary"
          class="mb-2"
          v-if="parseInt(used_count) < parseInt(max_count)"
          @click="(page = 'create'), (custom = newcustom())"
          >New</b-button
        >

        <span class="float-right fw-semi-bold text-primary pr-1"
          >Custom Fields Usage: {{ used_count }}/{{ max_count }}</span
        >

        <table class="table table-bordered sales-table">
          <thead>
            <th>Field Name</th>
            <th>Data Type</th>
            <th>Mandatory</th>
            <th>Show In Print</th>
            <th>Status</th>
            <th width="30px"></th>
          </thead>

          <tbody>
            <tr v-if="custom_field.length == 0">
              <td colspan="6" class="text-center">
                No custom fields to display
              </td>
            </tr>
            <template v-else>
              <tr
                v-for="(item, index) in custom_field"
                v-if="item.permissions != 'hide'"
                :key="item.id"
              >
                <td>{{ item.label_name }}</td>
                <td>{{ item.datatype }}</td>
                <td>{{ item.is_required == 1 ? "Yes" : "No" }}</td>
                <td>{{ item.print_show == 1 ? "Yes" : "No" }}</td>
                <td>{{ item.status == 1 ? "Active" : "InActive" }}</td>

                <td>
                  <b-dropdown
                    v-if="item.permissions == 'write'"
                    right
                    toggle-class="text-decoration-none"
                    variant="link"
                    no-caret
                    size="xs"
                  >
                    <template slot="button-content">
                      <i
                        class="glyphicon glyphicon-option-vertical theme-text-color"
                        style="
                          top: -6px !important;
                          letter-spacing: -5px !important;
                        "
                      ></i>
                    </template>
                    <b-dropdown-item
                      @click="(page = 'update'), updatecustom(index, item.id)"
                      >Edit</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click="
                        (index_column = item.id),
                          $root.$emit('bv::show::modal', 'deletefield')
                      "
                      >Delete</b-dropdown-item
                    >
                    <b-dropdown-item @click="fetchCustomConfigure(item.id)"
                      >Configure Access</b-dropdown-item
                    >
                  </b-dropdown>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <!--  create and udpate -->
    <div v-if="page == 'create' || page == 'update'">
      <b-row style="padding-left: 17px; padding-right: 17px; margin-top: -6px">
        <b-col cols="6">
          <h5 class="page-title">
            {{ page == "create" ? "Add Custom Field" : "Edit Custom Field" }}
          </h5>
        </b-col>
        <b-col cols="6" class="text-right pr-3">
          <a @click="page = ''">
            <i class="la la-remove la-lg text-decoration-none"></i>
          </a>
        </b-col>
      </b-row>
      <b-row class="px-4">
        <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-3">
          <div class="container-fluid">
            <b-alert
              class="alert-transparent alert-danger"
              :show="
                error_show &&
                (errors.any() || duplicate_msg != '' || !option_duplicate)
              "
            >
              <button
                type="button"
                @click="
                  error_show = !error_show;
                  duplicate_msg = '';
                  option_duplicate = !option_duplicate;
                "
                class="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <p
                v-for="item in errors.items"
                :key="item.id"
                v-if="item.scope == 'custom-field-form'"
                class="fw-semi-bold"
              >
                {{
                  item.field == "option 1" && item.rule == "required"
                    ? "Please provide at least one option."
                    : item.msg
                }}
              </p>
              <p class="fw-semi-bold" v-if="duplicate_msg != ''">
                {{ duplicate_msg }}
              </p>
              <p class="fw-semi-bold" v-if="!option_duplicate">
                The same option has been used more than once.
              </p>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-form
        @submit.prevent="onSubmit('custom-field-form')"
        data-vv-scope="custom-field-form"
        style="max-width: 768px"
      >
        <b-row class="px-4">
          <b-col cols="12" class="px-3">
            <b-form-group
              label-cols="4"
              label="Label name"
              label-for="label"
              label-class="required"
            >
              <b-input
                @input="duplicate_msg = ''"
                v-validate="'required|max:30'"
                v-model="custom.label_name"
                name="Label Name"
                data-vv-name="label name"
              ></b-input>
            </b-form-group>
            <b-form-group
              v-if="custom.datatype != 'checkbox'"
              label-cols="4"
              label="Place holder"
              label-for="label"
            >
              <b-input v-model="custom.placeholder"></b-input>
            </b-form-group>
            <b-form-group
              label-cols="4"
              label="Field type"
              label-for="field"
              label-class="required"
            >
              <v-select
                :clearable="false"
                :disabled="page == 'update' || false"
                label="text"
                index="type"
                v-validate="'required'"
                v-model="custom.datatype"
                :options="field_list"
                name="Field"
                data-vv-name="field type"
                @input="change_field($event)"
              ></v-select>
              <small
                class="mt-1"
                v-if="custom.datatype != null && custom.datatype != ''"
                >Remainig Fields: {{ custom_limit }}</small
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" class="px-3" v-if="custom.datatype == 'select'">
            <b-form-group
              label-for="option"
              label-cols="4"
              v-if="!bulk_options"
            >
              <div v-for="(option, index) in custom.options" :key="index">
                <div class="d-flex pb-2">
                  <b-form-input
                    :data-vv-name="'option ' + (index + 1)"
                    v-model="option.label"
                    v-validate="{ required: index == 0, max: 100 }"
                  ></b-form-input>
                  <i
                    @click="deleteOption(index)"
                    class="glyphicon glyphicon-trash my-auto mx-2"
                  ></i>
                </div>
              </div>
              <b-button
                @click="sortOptions()"
                size="xs"
                variant="outline-primary"
                class="float-right mb-3"
                >Sort in Alphabetical Order</b-button
              >
              <!-- <b-button
                @click="addOption"
                variant="outline-primary"
                size="xs"
                class="float-right mb-3"
              >Add Option</b-button>-->
              <b-dropdown
                size="xs"
                class="mb-3"
                variant="outline-primary"
                right
                split
              >
                <template slot="button-content">
                  <div @click="addOption">Add Option</div>
                </template>
                <b-dropdown-item @click="convertOptions()"
                  >Add options in bulk</b-dropdown-item
                >
              </b-dropdown>
            </b-form-group>
            <b-form-group label-for="options" label-cols="4" v-else>
              <textarea
                style="width: 100%"
                rows="10"
                class="form-control mb-3"
                v-model="bulk_option_labels"
              ></textarea>

              <b-button @click="addBulk()" variant="outline-primary" size="xs"
                >Add Options</b-button
              >
              <b-button
                @click="
                  bulk_options = !bulk_options;
                  bulk_option_labels = '';
                "
                variant="outline-light"
                size="xs"
                class="float-right text-dark"
                >Cancel</b-button
              >
            </b-form-group>
          </b-col>

          <b-col cols="12" class="px-3">
            <b-form-group
              label-cols="4"
              label="Defalut Value"
              label-for="defalut_value"
            >
              <b-form-textarea
                v-validate="'max:500'"
                v-model="custom.default_value"
                v-if="custom.datatype == 'textarea'"
                name="Default Value"
                data-vv-name="default value"
                @keyup="default_value_prev = false"
                @keydown="default_value_prev = false"
                @blur="default_value_prev = true"
              ></b-form-textarea>
              <v-select
                :clearable="
                  custom.default_value != '' && custom.default_value != null
                "
                @input="$event == null ? (custom.default_value = '') : ''"
                v-else-if="custom.datatype == 'select'"
                label="label"
                index="value"
                :options="custom.options"
                v-model="custom.default_value"
                name="Default Value"
              ></v-select>
              <DatePicker
                input-class="form-control"
                :format="$AppDetails.organization.date_format"
                value-type="format"
                v-else-if="custom.datatype == 'date'"
                style="width: 100% !important"
                lang="en"
                v-model="custom.default_value"
                name="Default Value"
              >
                <i class="fa fa-calendar text-dark" slot="calendar-icon" />
              </DatePicker>
              <b-form-checkbox
                unchecked-value="0"
                value="1"
                v-else-if="custom.datatype == 'checkbox'"
                v-model="custom.default_value"
                name="Default Value"
                >Is Defalut Checked</b-form-checkbox
              >
              <b-input-group
                v-else-if="custom.datatype == 'amount'"
                :prepend="orgCurrency"
                class="mb-2 mr-sm-2 mb-sm-0 product_currency"
              >
                <b-form-input
                  v-validate="'max:14|decimal:2'"
                  v-model="custom.default_value"
                  name="Default Value"
                  data-vv-name="default value"
                ></b-form-input>
              </b-input-group>
              <b-form-input
                v-else
                v-validate="
                  custom.datatype == 'email'
                    ? 'email'
                    : custom.datatype == 'amount' ||
                      custom.datatype == 'decimal' ||
                      custom.datatype == 'percent'
                    ? 'max:14|decimal:2'
                    : custom.datatype == 'phone'
                    ? 'phone'
                    : custom.datatype == 'url'
                    ? 'url'
                    : custom.datatype == 'number'
                    ? 'numeric'
                    : custom.datatype == 'textarea'
                    ? 'max:500'
                    : 'max:30'
                "
                v-model="custom.default_value"
                name="Default Value"
                data-vv-name="default value"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="px-3">
            <b-form-group
              label-cols="4"
              label="Is Required?"
              label-for="is_req"
            >
              <b-checkbox
                unchecked-value="0"
                value="1"
                v-model="custom.is_required"
                >Required</b-checkbox
              >
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            class="px-3"
            v-if="
              $route.meta.page != 'customerstatement' &&
              $route.meta.page != 'productsettings'
            "
          >
            <b-form-group
              label-cols="4"
              label="Show in Print"
              label-for="show_print"
            >
              <b-checkbox
                unchecked-value="0"
                value="1"
                v-model="custom.print_show"
                >Show</b-checkbox
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" class="px-3">
            <b-form-group
              label-cols="4"
              label="Status"
              label-for="Status"
              v-if="page == 'update'"
            >
              <b-checkbox unchecked-value="0" value="1" v-model="custom.status"
                >Mark as Active</b-checkbox
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          v-if="
            renderComponent && custom.label_name != '' && custom.datatype != ''
          "
          class="px-4"
        >
          <b-col class="px-3">
            <h5>Preview</h5>

            <CustomPreview
              :custom="custom"
              :disabled="true"
              :modelname="default_value_prev"
              page="settings"
            />
          </b-col>
        </b-row>
        <b-row v-if="page == 'update'" class="p-4">
          <b-col class="px-3">
            <b-form-group
              label-cols="4"
              label-for="field_name"
              label="API Field Name"
            >
              <b-input disabled v-model="custom.field_name"></b-input>
              <span class="text-muted">
                <small
                  >Use this placeholder when referring to this custom field in
                  an API call.</small
                >
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-4">
          <b-col>
            <div
              class="footer sidenav-footer"
              style="box-shadow: 0 -4px 5px -3px #ccc"
            >
              <div class="form-action" style="background: none !important">
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  class="btn-rounded mr-3"
                  :disabled="customized || bulk_options"
                >
                  <i
                    v-if="customized"
                    class="fa fa-circle-o-notch fa-spin mr-2"
                  ></i>
                  {{ page == "create" ? "Save" : "Update" }}
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <b-modal
      ref="deletefield"
      body-class="bg-white"
      size="md"
      ok-variant="primary"
      cancel-variant="light"
      id="deletefield"
      title="Delete"
      @ok="handledelete()"
    >
      <p>Are you sure you want to delete this column?</p>
    </b-modal>
    <b-modal
      ref="configureaccess"
      body-class="bg-white"
      ok-variant="primary"
      size="lg"
      cancel-variant="light"
      id="configureaccess"
      :title="'Read / Write Access for ' + cf_name"
      @ok="submitConfigureAccess()"
      ok-title="Save"
    >
      <table class="table table-hover">
        <thead>
          <th style="width: 40%">Role</th>
          <th class="text-center">Read and Write</th>
          <th class="text-center">Read Only</th>
          <th class="text-center">Hide</th>
        </thead>
        <tbody>
          <tr v-for="role in configure_list" :key="role.id">
            <td style="width: 40%" class="word-break">{{ role.role_name }}</td>
            <td class="text-center">
              <b-form-radio
                value="write"
                v-model="role.permission"
                :disabled="role.is_default == 'true'"
              ></b-form-radio>
            </td>
            <td class="text-center">
              <b-form-radio
                value="read"
                v-model="role.permission"
                :disabled="role.is_default == 'true'"
              ></b-form-radio>
            </td>
            <td class="text-center">
              <b-form-radio
                value="hide"
                v-model="role.permission"
                :disabled="role.is_default == 'true'"
              ></b-form-radio>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import vSelect from "vue-select";
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import DatePicker from "vue2-datepicker"; // vue datepicker
import $ from "jquery"; // for using jquery function
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification

export default {
  props: [
    "custom_field",
    "custom_prefix",
    "stg_menu",
    "max_count",
    "used_count",
  ],
  mixins: [notificationMixin],
  components: {
    DatePicker,
    CustomPreview,
    vSelect,
  },
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", //
      bulk_options: false,
      customized: false,
      error_show: false,
      custom: this.newcustom(),
      index_column: "",
      update_id: "",
      field_list: [
        {
          type: "text",
          text: "Text Box (Single Line)",
        },
        {
          type: "textarea",
          text: "Text Box(Multi Line)",
        },
        {
          type: "email",
          text: "Email",
        },
        {
          type: "phone",
          text: "Phone",
        },
        {
          type: "number",
          text: "Number",
        },
        {
          type: "decimal",
          text: "Decimal",
        },
        {
          type: "date",
          text: "Date",
        },
        {
          type: "select",
          text: "Select",
        },
        {
          type: "amount",
          text: "Amount",
        },
        {
          type: "url",
          text: "URL",
        },
        {
          type: "checkbox",
          text: "Checkbox",
        },
        {
          type: "percent",
          text: "Percent",
        },
      ],
      duplicate_msg: "",
      option_duplicate: true,
      bulk_option_labels: "",
      renderComponent: true,
    };
  },
  watch: {
    default_value_prev(val) {
      this.forceRerender();
    },
  },
  methods: {
    fetchCustomConfigure(id) {
      var data = JSON.stringify({
        id: id,
        stg_menu: this.stg_menu,
        app_id: process.env.VUE_APP_APP_ID,
      });
      this.$store.dispatch("settings/fetchCustomConfigure", data).then(() => {
        this.$root.$emit("bv::show::modal", "configureaccess");

        this.update_id = id;
      });
    },

    submitConfigureAccess() {
      this.$emit("ConfigureSubmit", {
        id: this.update_id,
        permissions: this.configure_list,
      });
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    addBulk() {
      this.bulk_options = !this.bulk_options;
      this.bulk_option_labels = this.bulk_option_labels.split("\n");
      var array = [];

      for (var i = 0; i < this.bulk_option_labels.length; i++) {
        array.push({
          label: this.bulk_option_labels[i],
          value:
            this.custom.options.length > i
              ? this.custom.options[i].value.toString()
              : (i + 1).toString(),
        });
      }
      this.custom.options = array;
    },
    convertOptions() {
      this.bulk_options = !this.bulk_options;
      this.bulk_option_labels = "";
      var array = [];
      this.custom.options.map((x) => array.push(x.label));
      this.bulk_option_labels = array.join("\n");
    },
    sortOptions() {
      if (!this.custom.options.every((x) => x.label == "")) {
        this.removeEmptyOptions();
        this.custom.options.sort((a, b) =>
          a.label > b.label ? 1 : b.label > a.label ? -1 : 0
        );
      }
    },
    removeEmptyOptions() {
      if (
        this.custom.datatype == "select" &&
        !this.custom.options.every((x) => x.label == "")
      ) {
        this.custom.options = this.custom.options.filter((x) => x.label != "");
      }
    },
    updatecustom(index, id) {
      this.index_column = index;
      this.duplicate_msg = "";
      this.option_duplicate = true;
      this.bulk_option_labels = "";
      this.update_id = id;
      this.custom = JSON.parse(JSON.stringify(this.custom_field[index]));
    },
    newcustom() {
      this.index_column = "";
      this.duplicate_msg = "";
      this.option_duplicate = true;
      this.bulk_option_labels = "";
      return {
        prefix: this.custom_prefix,
        suffix: "",
        field_name: "",
        datatype: "",
        label_name: "",
        is_required: 0,
        validation: "",
        default_value: "",
        placeholder: "",
        options: [],
        created: 0,
        print_show: 0,
        status: 1,
        duplicate_msg: "",
      };
    },
    async handledelete() {
      await this.$emit("handledelete", {
        index_value: this.index_column,
      });
      await this.$refs.deletefield.hide();
    },
    change_field(value) {
      var data = JSON.stringify({
        stg_menu: this.stg_menu,
        datatype: value,
      });
      this.$store.dispatch("settings/fetchCustomLimit", data);
      this.custom.is_required = 0;
      this.custom.default_value = "";
      this.custom.print_show = 0;
      if (value == "select") {
        this.custom.options.push({ value: "1", label: "" });
      } else {
        this.custom.options = [];
      }
    },

    async onSubmit(scope) {
      this.custom.suffix = await this.suffix;
      this.custom.field_name = await (this.page == "create"
        ? $.trim(this.custom.prefix + this.custom.suffix)
        : $.trim(this.custom.field_name));
      var format = /[.${}!@#$%^&*()_+={}/|:;"'/><.,₹`~]/;
      this.removeEmptyOptions();
      if (this.custom.label_name != "")
        if (format.test(this.custom.label_name)) {
          this.duplicate_msg =
            "Label name should not contain speacial characters";
        } else {
          for (var i = 0; i < this.custom_field.length; i++) {
            if (
              $.trim(this.custom_field[i].label_name) ==
                $.trim(this.custom.label_name) &&
              (this.index_column === "" || this.index_column != i)
            ) {
              this.duplicate_msg =
                "A custom field with this name already exist. Please provide a different name.";
              break;
            } else {
              this.duplicate_msg = "";
              continue;
            }
          }
        }
      if (this.custom.datatype == "select") {
        this.option_duplicate =
          this.custom.options.length ==
          new Set(this.custom.options.map((x) => x.label)).size;
      }
      this.$validator.validateAll(scope).then((result) => {
        if (result && this.duplicate_msg == "" && this.option_duplicate) {
          //if validation error occurs then display validation error messages
          this.$emit("onSubmit", {
            page: this.page,
            custom_field: 1,
            index: this.index_column,
            custom_data: this.custom,
            update_id: this.update_id,
            remaining_fields: this.custom_limit,
          });

          this.error_show = false;
          this.customized = false;
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.customized = false;
          this.error_show = true;
        }
      });
    },
    deleteOption(index) {
      this.custom.default_value = "";
      if (this.custom.options.length > 1) {
        this.custom.options.splice(index, 1);
      }
    },
    addOption() {
      this.custom.default_value = "";
      this.custom.options.push({
        value: (this.custom.options.length + 1).toString(),
        label: "",
      });
    },
  },
  computed: {
    ...mapState({
      configure_list: (state) => state.settings.configure_list,
      cf_name: (state) => state.settings.cf_name,
      message: (state) => state.settings.status_message,
      code: (state) => state.settings.code,
      custom_limit: (state) => state.settings.custom_limit,
    }),
    ...mapGetters(["orgCurrency"]),
    default_value_prev() {
      return this.custom.default_value;
    },
    page: {
      get() {
        return this.$store.state.settings.page;
      },
      set(val) {
        this.$store.state.settings.page = val;
      },
    },
    suffix() {
      var field = this;
      var temp = $.trim(field.custom.label_name.toLowerCase());
      var datatype =
        field.custom.datatype == "email"
          ? { validation: "email" }
          : field.custom.datatype == "amount" ||
            field.custom.datatype == "decimal" ||
            field.custom.datatype == "percent"
          ? { validation: "max:14|decimal:2" }
          : field.custom.datatype == "phone"
          ? { validation: "phone" }
          : field.custom.datatype == "url"
          ? { validation: "url" }
          : field.custom.datatype == "number"
          ? { validation: "max:14|numeric" }
          : field.custom.datatype == "textarea"
          ? { validation: "max:500" }
          : field.custom.datatype == "text"
          ? { validation: "max:100" }
          : field.custom.datatype == "date"
          ? { validation: "" }
          : field.custom.datatype == "checkbox"
          ? { validation: "" }
          : field.custom.datatype == "select"
          ? { validation: "" }
          : "";
      field.custom.validation = datatype.validation;
      if (field.custom.is_required == 1) {
        field.custom.validation +=
          field.custom.validation != "" ? "|required" : "required";
      }
      temp = temp.replace(/ /g, "_");
      field.custom.suffix = temp;
      return field.custom.suffix;
    },
  },
};
</script>